const ITEMS = [
    "40FT Trailers",
    "50FT Trailers",
    "60FT Trailers",
    "Pan India ODC",
    "Loose Cargo",
    "Long-Distance Haulage",
];

function Diamond() {
    return (
        <svg viewBox="0 0 12 12" className="h-3 w-3 shrink-0 text-brand" aria-hidden="true">
            <rect x="2" y="2" width="8" height="8" transform="rotate(45 6 6)" fill="currentColor" />
        </svg>
    );
}

export default function Marquee() {
    return (
        <div
            className="overflow-hidden border-y border-ink/10 bg-ink py-5 text-paper"
            data-testid="editorial-marquee"
        >
            <div className="flex w-max animate-marquee">
                {[0, 1].map((n) => (
                    <div key={n} aria-hidden={n === 1} className="flex shrink-0 items-center">
                        {ITEMS.map((item) => (
                            <span key={item} className="flex items-center">
                                <span className="whitespace-nowrap px-7 font-display text-2xl font-bold uppercase tracking-tight sm:text-3xl">
                                    {item}
                                </span>
                                <Diamond />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
